import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { getProcedure } from "../../api/procedure";
import { getProcedureRole } from "../../api/procedure/getProcedureRole";
import { getStage } from "../../api/stage";
import { getAnswer } from "../../api/stage/answers";
import Answers from "../../components/Stages/Answers/Answers";
import { useTranslationHook } from "../../hooks";
import { setLoading } from "../../store/UI";
import { Procedure, ProcedureRole } from "../../types/model/procedure";
import { Answer, Stage } from "../../types/model/stage";

const StageAnswers = () => {
  const { t } = useTranslationHook();
  const dispatch = useDispatch();

  const { accountId, projectId, activityId, procedureId, stageId } =
    useParams<{
      accountId: string;
      projectId: string;
      activityId: string;
      procedureId: string;
      stageId: string;
    }>();

  const [stage, setStage] = useState<Stage>();
  const [answer, setAnswer] = useState<Answer>();
  const [procedure, setProcedure] = useState<Procedure>();
  const [procedureRole, setProcedureRole] = useState<ProcedureRole>();
  const [loadingLocal, setLoadingLocal] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!projectId || !activityId || !procedureId || !stageId) return;

      dispatch(setLoading(true));

      try {
        const [
          stageRes,
          answerRes,
          procedureRes,
          procedureRoleRes,
        ] = await Promise.all([
          getStage(Number(projectId), Number(activityId), Number(procedureId), Number(stageId)),
          getAnswer(Number(projectId), Number(activityId), Number(procedureId), Number(stageId)),
          getProcedure(Number(projectId), Number(activityId), Number(procedureId)),
          getProcedureRole(Number(projectId), Number(activityId), Number(procedureId)),
        ]);

        setStage(stageRes);
        setAnswer(answerRes);
        setProcedure(procedureRes);
        setProcedureRole(procedureRoleRes);

        enqueueSnackbar(t("stages.answers.answers-loaded"), {
          variant: "success",
        });
      } catch (error) {
        console.error(error);
        enqueueSnackbar(t("stages.answers.error-loading"), {
          variant: "error",
        });
      } finally {
        dispatch(setLoading(false));
        setLoadingLocal(false);
      }
    };

    fetchData();
  }, [projectId, activityId, procedureId, stageId, dispatch]);

  if (loadingLocal || !stage || !procedure || !procedureRole) return null;

  return (
    <Answers
      stage={stage}
      answer={answer}
      procedureRole={procedureRole}
      procedure={procedure}
      accountId={Number(accountId)}
      projectId={Number(projectId)}
      activityId={Number(activityId)}
      procedureId={Number(procedureId)}
    />
  );
};

export default StageAnswers;